import { handleActions, Action } from "redux-actions";
import { PRODUCT, SCOPE_BRAND_SET } from "constants/action-types";
import { List, OrderedSet } from "immutable";
export interface IState {
    availabilityId?: string;
    arrivingInventory?: List<string>;
    replenishmentGroupIds?: List<string>;
    id?: string;
    error?: Error;
    isFetching: boolean;
    isFetchingAvailability: boolean;
    isFetchingReplenishments: boolean;
    variants?: OrderedSet<string>;
    warehouses?: OrderedSet<string>;
}

export const initialState: IState = {
    availabilityId: undefined,
    id: undefined,
    error: undefined,
    isFetching: false,
    variants: undefined,
    warehouses: undefined,
    replenishmentGroupIds: undefined,
    isFetchingAvailability: false,
    isFetchingReplenishments: false,
};

export const productReducer = handleActions<IState, any>(
    {
        [SCOPE_BRAND_SET]: () => {
            return initialState;
        },
        [PRODUCT.FETCH.START]: (state: IState, { error, payload }) => {
            const { variants } = state;
            return {
                ...initialState,
                isFetching: true,
                variants: variants?.includes(payload.id) ? variants : undefined,
            };
        },
        [PRODUCT.FETCH.COMPLETED]: (state: IState, { error, payload }) => {
            if (error) {
                return {
                    ...state,
                    error: payload,
                    id: undefined,
                    isFetching: false,
                };
            }
            const { variants } = state;
            return {
                ...initialState,
                warehouses: state.warehouses,
                id: payload,
                isFetching: false,
                variants: variants?.includes(payload) ? variants : undefined,
            };
        },
        [PRODUCT.VARIANTS.FETCH.COMPLETED]: (state: IState, { error, payload }: Action<string[]>): IState => {
            if (error) {
                return state;
            }
            return {
                ...state,
                variants: OrderedSet(payload),
            };
        },
        [PRODUCT.WAREHOUSES.FETCH.COMPLETED]: (
            state: IState,
            { error, payload }: Action<{ warehouseIds: string[] }>,
        ): IState => {
            const { warehouseIds } = payload;
            if (error) {
                return state;
            }
            return {
                ...state,
                warehouses: OrderedSet(warehouseIds),
            };
        },
        [PRODUCT.WAREHOUSE.AVAILABILITY.FETCH.START]: (state: IState): IState => {
            return {
                ...state,
                availabilityId: undefined,
                isFetchingAvailability: true,
            };
        },
        [PRODUCT.WAREHOUSE.AVAILABILITY.FETCH.COMPLETED]: (
            state: IState,
            { error, payload }: Action<{ availabilityId: string }>,
        ): IState => {
            const { availabilityId } = payload;
            if (error) {
                return {
                    ...state,
                    isFetchingAvailability: false,
                };
            }
            return {
                ...state,
                availabilityId,
                isFetchingAvailability: false,
            };
        },
        // [PRODUCT.AVAILABILITY.FETCH.COMPLETED]: (state: IState, { error, payload }: Action<IAvailabilityPayload>): IState => {
        //     const { availabilities, warehouses } = payload;
        //     if (error) {
        //         return state;
        //     }
        //     return {
        //         ...state,
        //         availabilities: List<string>(availabilities),
        //         warehouses: OrderedSet(warehouses),
        //     };
        // },
        [PRODUCT.WAREHOUSE.INVENTORY.FETCH.COMPLETED]: (state: IState, { error, payload }: Action<any>): IState => {
            const { arrivingInventory } = payload;
            if (error) {
                return state;
            }
            return {
                ...state,
                arrivingInventory: List<string>(arrivingInventory),
            };
        },
        [PRODUCT.WAREHOUSE.REPLENISHMENTS.FETCH.START]: (state: IState): IState => {
            return {
                ...state,
                replenishmentGroupIds: undefined,
                isFetchingReplenishments: true,
            };
        },
        [PRODUCT.WAREHOUSE.REPLENISHMENTS.FETCH.COMPLETED]: (
            state: IState,
            { error, payload }: Action<any>,
        ): IState => {
            const { replenishmentGroupIds } = payload;
            if (error) {
                return {
                    ...state,
                    isFetchingReplenishments: false,
                };
            }
            return {
                ...state,
                replenishmentGroupIds: List<string>(replenishmentGroupIds),
                isFetchingReplenishments: false,
            };
        },
    },
    initialState,
);
